import React, { useEffect, useState } from "react";
import DateRangePicker from "../../../components/common/DateRangePicker";
import { useTranslation } from "react-i18next";
import ReactApexChart from "react-apexcharts";
import BranchDropdown from "../Overview/BranchDropdown";
import { MultiSelect } from "primereact/multiselect";
import { useDispatch, useSelector } from "react-redux";
import { getBranchListWithCity } from "store/actions/branchSlice";
import { orderSpaceType, spaceTypeOptions } from "components/constants/DropdownOptions";

const defaultOptions = {
  chart: {
    id: "styled-bar",
    stacked: true,
    toolbar: { show: false },
    zoom: { enabled: true },
    background: "transparent",
  },
  xaxis: {
    categories: [], // <-- to be updated dynamically
    labels: {
      show: true,
      style: {
        colors: ["#A4A4A4"],
        fontSize: "12px",
      },
    },
    axisBorder: {
      show: false,
    },
  },
  yaxis: {
    labels: {
      show: true,
      align: "left",
      style: {
        colors: ["#A4A4A4"],
        fontSize: "15px",
      },
      formatter: function (value) {
        return `${value.toFixed(1)} 🟊`;
      },
    },
    min: 1,
    max: 5,
    tickAmount: 4,
  },
  grid: { show: false },
  fill: {
    colors: ["#ECECEC"],
    opacity: 1,
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "50%",
      borderRadius: 12,
      endingShape: "rounded",
    },
  },
  dataLabels: {
    enabled: true,
    style: {
      colors: ["#fff"],
      fontSize: "10px",
      fontWeight: "bold",
    },
    formatter: function (val) {
      return `${val} SAR`;
    },
  },
  annotations: {
    yaxis: [
      {
        y: 4.2,
        borderColor: "#101010",
        strokeDashArray: [2, 5],
        label: {
          borderColor: "#30322C",
          style: {
            color: "#fff",
            background: "#30322C",
          },
          text: "Average Rating 4.2",
          position: "left",
          offsetX: 40,
        },
      },
    ],
  },
  tooltip: {
    theme: "light",
    enabled: true,
    y: {
      formatter: (val) => `${val} Rating`,
    },
  },
  colors: ["#D9D9D9"],
  states: {
    hover: { filter: { type: "none" } },
    active: { filter: { type: "none" } },
  },
};

const ReviewSummary = ({
  ratingDashboardDetails,
  dates,
  setDates,
  branches,
  setBranches,
  spaceTypes,
  setSpaceTypes,
  getAllData,
  handleReset,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { branchesWithCity } = useSelector((state) => state.Branches);

  useEffect(() => {
    dispatch(getBranchListWithCity());
  }, []);

  const [options, setOptions] = useState(defaultOptions);
  const [series, setSeries] = useState([
    {
      name: t("Bookings"),
      data: [],
    },
  ]);

  useEffect(() => {
    if (ratingDashboardDetails?.monthly) {
      setOptions((prev) => ({
        ...prev,
        xaxis: {
          ...prev.xaxis,
          categories: ratingDashboardDetails?.monthly?.categories || [],
        },
        annotations: {
          ...prev.annotations,
          yaxis: [
            {
              ...prev.annotations.yaxis[0],
              y: ratingDashboardDetails.averageRating,
              label: {
                ...prev.annotations.yaxis[0].label,
                text: `${t("Average Rating")} ${
                  ratingDashboardDetails.averageRating
                }`,
              },
            },
          ],
        },
      }));

      setSeries([
        {
          name: t("Bookings"),
          data: ratingDashboardDetails?.monthly?.data || [],
        },
      ]);
    }
  }, [ratingDashboardDetails]);

  const handleBranchApply = () => {
    getAllData({ actionType: "SEARCH" });
  };

  const handleSelectionChange = (newSelected) => {
    setBranches(newSelected);
  };

  return (
    <React.Fragment>
      <div>
        <div className="g_between">
          <h2 className="fs_20">{t("Reviews Summery")}</h2>
          <div className="d-flex gap-3 common_filter">
            <div className="buttons">
              <button
                className="search_btn"
                onClick={() => getAllData({ actionType: "SEARCH" })}
              >
                {t("Search")}
              </button>
              <button className="reset_btn" onClick={handleReset}>
                {t("Reset")}
              </button>
            </div>
            <MultiSelect
              value={spaceTypes}
              onChange={(e) => setSpaceTypes(e.value)}
              options={orderSpaceType}
              selectAllLabel={t("Select All")}
              // display="chip"
              optionLabel="name"
              placeholder={"Space Type"}
              maxSelectedLabels={3}
              className="filter_multi_select"
            />
            <BranchDropdown
              data={branchesWithCity}
              label={t("Branch")}
              allLabel={t("Choose All Branches")}
              resetLabel={t("Reset all")}
              onSelectionChange={handleSelectionChange}
              selectedData={branches}
              handleApply={handleBranchApply}
            />
            <DateRangePicker dates={dates} setDates={setDates} />
          </div>
        </div>
        <div>
          <h2 className="fs_14 my-2">{t("Total Ratings")}</h2>
          <h3 className="fs_28 ">
            {ratingDashboardDetails?.totalRatings ?? 0}
          </h3>
        </div>
        <div className="reviews_summary_chart">
          <ReactApexChart
            options={options}
            series={series}
            type="bar"
            height={350}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ReviewSummary;
